
import { Emitter } from "@utils/events";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "CiClearRefinements",
  props: {
    variant: {
      type: String as PropType<"disabled" | "visibility">,
      default: "disabled",
    },
    withIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const handleClickRefinement = (refine: () => unknown) => {
      Emitter.emit("ci::clear-refinement::ais");
      refine();
    };

    const isDisabled = (canRefine: boolean) => {
      if (props.variant !== "disabled") return false;

      return !canRefine;
    };

    const isVisible = (canRefine: boolean) => {
      if (props.variant !== "visibility") return true;

      return canRefine;
    };

    return {
      handleClickRefinement,
      isDisabled,
      isVisible,
    };
  },
});
